import { UploadFile } from "antd/lib/upload/interface";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form"
import { useAuthenticationDataContext } from "../../Helpers/AuthenticationDataProvider";
import { usePopupContext } from "../../Helpers/PopupProvider";
import useFetchWrapper, { HttpResponse } from "../../Helpers/useFetchWrapper";
import useObjectHelper from "../../Helpers/useObjectHelper";

import { CreateHelpRequest, Help, Props } from "./HelpRequest.model";

export const useHelpRequest = ({onClose}: Props) => {
	const [topics, setTopics] = useState<string[]>();
	const [files, setFiles] = useState<UploadFile<any>[]>([]);
	const [isSubmitted, setIsSubmitted] = useState(false);
	const { get, postFormData } = useFetchWrapper();
	const { cleanObj, objToFormData } = useObjectHelper();
	const { onPopupClose, onPopupOpen } = usePopupContext();

	const { email } = useAuthenticationDataContext();
	const { control, formState: { errors }, handleSubmit } = useForm(
		{
			defaultValues: {
				description: '',
				reportType: 'none',
				resourceReported: undefined,
				shortDescription: '',
				topics: undefined,
				userReported: undefined,
			}
		}
	);

	const getIconByFileType = (extension: string | undefined) => {
		switch (extension) {
			case "image/jpg":
			case "image/jpeg":
			case "image/png": return "file-image";
			case "application/pdf": return "file-pdf";
			case "application/vnd.openxmlformats-officedocument.wordprocessingml.document": return "file-word";
			case "video/quicktime": return "file-video";
			default: return "file-alt";
		}
	}
	
	const getTopics = async() => {
		const response: HttpResponse<string[]> = await get('/review/feedback-topic');
		if(response.parsedBody){
			setTopics(response.parsedBody);
		}
	}

	const onChangeFiles = ({fileList}: any) => {
		setFiles(fileList);
	}

	const submitFeedback = async (data: Help) => {
		const content: { [key: string]: any } = files.reduce((acc, curr, index) => ({ ...acc, [`content${index + 1}`]: curr.originFileObj }), {});
		const formData: CreateHelpRequest = {
			feedbackType: "Help",
			...cleanObj(data),
			...content
		}
		const response = await postFormData('/review/feedback', objToFormData(formData));
		if (response.status === 200) {
			setIsSubmitted(true);
		}
	}

	useEffect(() => {
		getTopics();
		onPopupOpen();
	}, []);

	return {
		control,
		errors,
		getIconByFileType,
		handleSubmit,
		onChangeFiles,
		onPopupClose,
		state: {
			email,
			files,
			isSubmitted,
			topics,
		},
		submitFeedback
	}
}